export const VOLUNTEER_REGISTRATION_SUCCESS = 'VOLUNTEER_REGISTRATION_SUCCESS';
export const VOLUNTEER_REGISTRATION_FAILURE = 'VOLUNTEER_REGISTRATION_FAILURE';
export const GET_LIST_COUNTRIES_SUCCESS = 'GET_LIST_COUNTRIES_SUCCESS';
export const GET_LIST_COUNTRIES_FAILURE = 'GET_LIST_COUNTRIES_FAILURE';
